import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App, { initParamsFromUrlAndCookies } from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";

// Initialize URL params and cookies (e.g. referral_code) before app renders
initParamsFromUrlAndCookies();

// const tagManagerArgs = {
//   gtmId: "G-BM1Q9LFMPG",
// };

// TagManager.initialize(tagManagerArgs);

Sentry.init({
  dsn: "https://e5567e275b4804034cec5edd03fc96b6@o4503963049000960.ingest.sentry.io/4506156332089344",
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["https://nmzxzzoshbpsqpvplqao.supabase.co"],
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
